import { createSlice } from "@reduxjs/toolkit";

export const myredcucer = createSlice({
  name: "myredcucer",
  initialState: {},
  reducers: {},
});